import { memo, Fragment } from 'react'
import { selectors } from 'builder/modules/careerCoaching'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import NoCoachAvailable from './components/NoCoachAvailable'
import Header from './components/Header'
import { Container } from './styles'
import { HEADER_SUBTEXT_MOBILE, HEADER_TEXT_MOBILE } from './constants'
import Footer from './components/Footer'

interface SessionTabsProps {
  isLoaded: boolean
  isFailed: boolean
}

const SessionTabs = ({ isLoaded, isFailed }: SessionTabsProps): JSX.Element => {
  const coaches = useTypedSelector(selectors.coaches)

  if ((isLoaded || isFailed) && !coaches.length) {
    return (
      <Container>
        <NoCoachAvailable />
      </Container>
    )
  }

  return (
    <Fragment>
      {isLoaded && (
        <Container>
          <Header heading={HEADER_TEXT_MOBILE} description={HEADER_SUBTEXT_MOBILE} />
          <Footer />
        </Container>
      )}
    </Fragment>
  )
}
export default memo(SessionTabs)
